module.exports = __webpack_public_path__ + "static/Rome-581cb2aa5485815da8bea1b2870375bd.png";